import React from 'react';
import { Card, BUTTON_TYPES } from 'day8-react/build/new-components';

const InfoCards = () => (
  <div className="max-width-md margin-auto d8-l-auto-grid">
    <Card
      template="ImageCard"
      imageCardTemplate="VerticalSplit"
      heading="Destination guide"
      subheading="Explore our destinations in three different continents!"
      cta={{
        text: 'Explore destinations',
        link: '/destination-guide',
        buttonType: BUTTON_TYPES.BARE,
        iconFlip: true,
        icon: 'arrow-right'
      }}
      image={{
        url: 'https://assets.theskiweek.com/wp-content/uploads/2020/07/140318153407_MG_0350-Photo-by-Fabian-Wester.jpg',
        alt: 'Man standing on roof with skis'
      }}
      imagePadding
    />
    <Card
      template="ImageCard"
      imageCardTemplate="VerticalSplit"
      heading="The Ski Week Crew Finder"
      subheading="This group will help you find free spots in already booked flats. If you need to complete an existing booking, you can also advertise your free spots here."
      cta={{
        text: 'Find out more',
        link: '/crew-finder',
        buttonType: BUTTON_TYPES.BARE,
        iconFlip: true,
        icon: 'arrow-right'
      }}
      image={{
        url: 'https://assets.theskiweek.com/wp-content/uploads/2020/07/TSW.W2.Asa_Steinars210.jpg',
        alt: 'People standing on slope'
      }}
      imagePadding
    />
  </div>
);


export default InfoCards;
